module.exports = __webpack_public_path__ + "static/media/cq_editor_testo_centro b.4b52d19b.svg";